import { render, staticRenderFns } from "./ListagemModeloDocumentacaoAcessoria.vue?vue&type=template&id=2e5287ac"
import script from "./ListagemModeloDocumentacaoAcessoria.vue?vue&type=script&lang=js"
export * from "./ListagemModeloDocumentacaoAcessoria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports